import { notesConstants } from "../constants";

const initialState = {};

export function notes(state = initialState, action) {
  switch (action.type) {
    case notesConstants.NOTES_REQUEST:
      return {
        isLoading: true,
      };

    case notesConstants.NOTES_SUCCESS:
      return {
        list: action.list,
      };

    case notesConstants.NOTES_FAILURE:
      return {
        error: action.error,
      };

    default: {
      return state;
    }
  }
}
